import { DashboardPage } from "./DashboardPage";

const Dashboard = () => {
	return <DashboardPage />;
};
export default Dashboard;
